import script from "./HrBasicDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HrBasicDialog.vue?vue&type=script&setup=true&lang=js"

import "./HrBasicDialog.vue?vue&type=style&index=0&id=309a6a4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-309a6a4e"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
